import { Col, Row } from 'react-bootstrap';
import type { FunctionComponent } from 'react';

import Header from '../common/Header';

/**
 * Auth centered layout component (without the marketing blurb).
 */
const CenteredLayout: FunctionComponent = ({ children }) => (
  <div className="fossa-auth__layout--centered">
    <Header />
    <Row className="fossa-auth__layout">
      <Col sm={12}>
        {children}
      </Col>
    </Row>
  </div>
);

export default CenteredLayout;
